import createReactComponent from '../createReactComponent';
export default createReactComponent('cloud', 'Cloud', [["path",{"d":"M20.278 17.497c3.678-3.154-.214-7.384-4.256-7.384C13.175-.969-3.526 8.197 3.875 16.55","key":"svg-0"}]]);